document.addEventListener('DOMContentLoaded', function () {
    function updateViewportHeightVar() {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    function checkWindowWidth() {
        const zoomContainer = document.querySelector('.mobile-zoom-container');
        if (window.innerWidth >= 768) {
            zoomContainer.style.display = 'none';
        }
    }

    checkWindowWidth();
      
    window.addEventListener('resize', () => {
        updateViewportHeightVar();
        checkWindowWidth();
    });
    window.addEventListener('orientationchange', updateViewportHeightVar);
    updateViewportHeightVar();

    // Zoom button for each image
    document.querySelectorAll('.btn-zoom-mobile').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();

            // Find the image associated with this button
            let img = btn.closest('.product-single__media')?.querySelector('img');
            if (!img) {
                img = btn.parentElement.querySelector('img');
            }
            if (!img) return;

            // Select all unique product images, maintaining appearance order
            const allImgs = Array.from(document.querySelectorAll('.product-single__media img'));
            const uniqueImgs = [];
            const seenSrcs = new Set();

            allImgs.forEach(imgEl => {
                const src = imgEl.getAttribute('data-src-high-resolution') || imgEl.getAttribute('data-src') || imgEl.src;
                if (!seenSrcs.has(src)) {
                    seenSrcs.add(src);
                    uniqueImgs.push(imgEl);
                }
            });

            // Find the index of the clicked image within unique images
            const clickedSrc = img.getAttribute('data-src-high-resolution') || img.getAttribute('data-src') || img.src;
            let startIndex = uniqueImgs.findIndex(imgEl => {
                const src = imgEl.getAttribute('data-src-high-resolution') || imgEl.getAttribute('data-src') || imgEl.src;
                return src === clickedSrc;
            });

            // If not found for any reason, force to 0
            if (startIndex < 0) startIndex = 0;

            openZoomModal(startIndex, uniqueImgs);
        });
    });

    function openZoomModal(startIndex, uniqueImgsParam) {
        // If uniqueImgsParam is passed, use it, if not, get it again (for compatibility)
        let uniqueImgs = uniqueImgsParam;
        if (!uniqueImgs) {
            const allImgs = Array.from(document.querySelectorAll('.product-single__media img'));
            uniqueImgs = [];
            const seenSrcs = new Set();
            allImgs.forEach(img => {
                const src = img.getAttribute('data-src-high-resolution') || img.getAttribute('data-src') || img.src;
                if (!seenSrcs.has(src)) {
                    seenSrcs.add(src);
                    uniqueImgs.push(img);
                }
            });
        }

        if (!uniqueImgs.length) return;

        // Reorder images: move first to end
        const firstImg = uniqueImgs.shift();
        uniqueImgs.push(firstImg);

        // Adjust initial index
        startIndex = (startIndex === 0) ? uniqueImgs.length - 1 : startIndex - 1;

        // Fill modal slider with unique images only, in correct order
        const contentZoom = document.querySelector('.mobile-zoom-container .content-zoom');
        contentZoom.innerHTML = `
            <div class="swiper mySwiper">
                <div class="swiper-wrapper">
                    ${uniqueImgs.map((img, i) => `
                        <div class="swiper-slide">
                            <div class="swiper-zoom-container">
                                <img src="${img.getAttribute('data-src-high-resolution') || img.getAttribute('data-src') || img.src}" alt="${img.alt || ''}" />
                            </div>
                        </div>
                    `).join('')}
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
                <div class="container-swiper-pagination">
                    <div class="content-pagination-swiper">
                        <div class="swiper-pagination"></div>
                        <div class="zoom-slide-counter"></div>
                    </div>
                </div>
            </div>
        `;

        // Check if product slider has progress bar and apply to zoom modal
        const productMediaGroup = document.querySelector('.product-single__media-group');
        if (productMediaGroup && productMediaGroup.classList.contains('slick-progress-bar')) {
            const zoomSwiper = contentZoom.querySelector('.swiper');
            zoomSwiper.classList.add('slick-progress-bar');
        }

        // Save current scroll position
        const scrollY = window.scrollY;
        
        // Show modal and disable body scroll
        document.querySelector('.mobile-zoom-container').style.display = 'flex';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
        
        // change z-index of header when modal is opened
        document.querySelector('.header-container').style.zIndex = '0';

        // Initialize Swiper with correct number of unique images and initial slide
        const swiper = new Swiper(".mySwiper", {
            zoom: true,
            initialSlide: startIndex,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                type: 'bullets',
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
            },
        });

        // Update slide counter
        function updateZoomSlideCounter() {
            const counter = contentZoom.querySelector('.zoom-slide-counter');
            if (counter) {
                const current = swiper.realIndex + 1;
                const total = uniqueImgs.length;
                counter.textContent = current + ' / ' + total;
            }
        }

        // Initial counter state
        updateZoomSlideCounter();

        // Update on slide change
        swiper.on('slideChange', updateZoomSlideCounter);
        
        // Close modal
        document.querySelector('.close-zoom').onclick = function () {
            document.querySelector('.mobile-zoom-container').style.display = 'none';
            contentZoom.innerHTML = '';
            
            // Restore scroll to original position
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            window.scrollTo(0, scrollY);
            
            // restore z-index of header when modal is closed
            document.querySelector('.header-container').style.zIndex = '20';
            
            if (swiper) {
                swiper.destroy(true, true);
            }
        };
    }
});